






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
// import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";

@Component({
  name: "patientName",
  components: {
    questionSettingTemplate,
    // EditSortDialog,
  },
})
export default class patientName extends Vue {
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  value!: any;
  @Prop({
    type: Boolean,
    default: false,
  })
  disabled?: any;

  @Watch("value", { deep: true, immediate: true })
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  private loading = false;
  // private catalogList: any[] = [];
  // private editSortDialogKey = Math.random();
  private postForm = {
    title: "请填写患者姓名首字母缩写", // 标题
    required: "1", // 是否必填
    coontent: "",
    itemScore: 0,
    rightText: "",
    scoreRule: "",
    catalogIds: [],
    whetherJoinQuestionBank: false,
    jsonConfig: {
      showIndex: true,
      inputForm: "NONE",
      inputNumberMin: "",
      inputNumberMax: "",
      inputNumberPrecision: "",
      inputMin: "",
      inputMax: "",
    },
  };

  private rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],

    required: [{ required: true, message: "请选择是否必填", trigger: "blur" }],
    coontent: [{ required: false, type: "string", trigger: "blur" }],
    // itemScore: [{ required: true, message: "请填写题目分值", trigger: "blur" }],
    // rightText: [{ required: true, message: "请填写答案", trigger: "blur" }],
    // scoreRule: [{ required: true, message: "请选择得分规则", trigger: "blur" }],
    // catalogIds: [{ required: true, type: "array", message: "请选择分类名", trigger: "blur" }],
    // whetherJoinQuestionBank: [{ required: true, message: "请选择是否加入题库", trigger: "blur" }],
  };

  get questionnaireType(): EnumCommunityType {
    return QuestionnaireEditModule.questionnaireType as any;
  }
  get communityType(): EnumCommunityType {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams(): any {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType,
    };
  }
  @Watch("postForm", { deep: true })
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }

  getFormInstance() {
    return this.$refs.postForm as any;
  }
  // remoteMethod(query?: any) {
  //   this.loading = true;
  //   getCatalog({ ...this.basicParams, name: query, pageSize: 50, pageNum: 1 })
  //     .then((res: any) => {
  //       this.catalogList = res.rows || [];
  //     })
  //     .finally(() => (this.loading = false));
  // }
  // catalogFocus() {
  //   if (this.catalogList.length === 0) {
  //     this.remoteMethod();
  //   }
  // }
  openSortDialog() {
    (this.$refs.editSortDialog as any).onShow({ isBusinessTypeDisable: true, formData: { businessType: this.questionnaireType } });
  }
  async validate() {
    return await this.getFormInstance()
      .validate()
      .catch((err: any) => {
        return err;
      });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }

  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
}
